import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import autoTable from 'jspdf-autotable';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';
import { defaultPageLimit} from "../../shared/components/ag-grid/ag-grid.model";
import { NgForm } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  pinnedIconsList=[]
  public isselecte = new Subject<boolean>();
  public headerHeight= new BehaviorSubject<number>(50);
  public getMapData = new BehaviorSubject<boolean>(false);
  public getTemplateData = new BehaviorSubject<boolean>(false);


  constructor() { }

  //#region dowonload pdf or print
 
  generatePdfAndPrint(data: any[], columns: any[], fileName: string): void {
    const doc = new jsPDF({orientation:"landscape"});
    const headData = [columns?.map(column => column?.title)];
    const bodyData = data?.map(row => columns?.map(column => {
      // Convert boolean values to "yes" or "no"
      //const value = row[column?.name];
      let value = row[column?.name];
      if (column?.name === 'leadScoreId') {
        value = row['leadScoreName'];
      }else  if (column?.name === 'intentToBuyId') {
        value = row['intentToBuyName'];
      }
    
    //  return value;
      return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value;
  }));
    autoTable(doc, {
      styles: { fontSize: 8},
      head: headData,
      body:bodyData,
      headStyles:{fontSize:9,valign:"middle"}
    })
        doc.save(`${fileName}.pdf`);
       // Get the data URI of the PDF
      const dataUri = doc.output("datauristring");
      // Open the PDF in a new window for printing
      const printWindow = window?.open();
      if (printWindow) {
        printWindow?.document?.write(`<iframe width="100%" height="100%" src="${dataUri}" download="${fileName}.pdf" title="${fileName}.pdf"></iframe>`);
        printWindow?.document?.close();
        // printWindow?.print(); // Open the print dialog
      } else {
        // Handle popup blocked or failed to open
        alert('Popup blocked! Please enable popups for this site and try again.');
      }
      // const printWindow = window?.open(dataUri, '_blank');
      // if (printWindow) {
      //   printWindow?.print(); // Open the print dialog
      // } else {
      //   // Handle popup blocked or failed to open
      //   alert('Popup blocked! Please enable popups for this site and try again.');
      // }
  
  }
  //#endregion dowonload pdf or print


  //#region export file xlsx
 
  export(header:any[],dataList:any[] ,fileName): void {
    const modifiedDataList = dataList.map(item => {
      return item.map(value => {
          return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value;
      });
  });
    /* generate worksheet */
    const data = [...header,...modifiedDataList]
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);
  }
  
  //#endregion
  private selectedDateSubject = new BehaviorSubject<any>(undefined);

  setSelectedDate(data: any): void {
    this.selectedDateSubject.next(data);
  }

  getSelectedDate(): Observable<string> {
    return this.selectedDateSubject.asObservable();
  }
  processServersideApiResponse(res, grid, gridApi, pagination, getAll: boolean) {
    if (res.isSuccess) {
      setTimeout(() => {
        this.hideLoading(gridApi);
        var response = res?.response;
        const allRows = response;
        gridApi?.api.paginationSetPageSize(pagination == undefined || pagination?.pageSize == undefined ? defaultPageLimit : pagination?.pageSize);
        if(grid?.dataModel?.storageName) {
        } else {
          gridApi?.api?.setRowData(allRows);
        }
      //  grid.updateServersidePaginationData(firstTabEntry == undefined || firstTabEntry == null ? 0 : firstTabEntry[0]?.total_rows, firstTabEntry == undefined || firstTabEntry == null ? 0 : firstTabEntry[0]?.total_pages, pagination == undefined ? 1 : pagination?.page, pagination?.pageSize == undefined ? defaultPageLimit : pagination?.pageSize);
        gridApi?.api?.refreshCells();
      }, 100);
    } else {
      this.hideLoading(gridApi);
     // grid?.updateServersidePaginationgetallData(1, 0);
      gridApi?.api?.setRowData([]);
    }
  }


  showLoading(params) {
    setTimeout(() => {
      params?.api.showLoadingOverlay();
    }, 0);
  }
  hideLoading(params) {
    params?.api?.hideOverlay();
  }
  public markFormAsTouchedAndDirty(form: NgForm) {
    Object.keys(form?.controls).forEach(field => {
      const control = form?.controls[field];
      control?.markAsTouched({ onlySelf: true });
      control?.markAsDirty({ onlySelf: true });
    });
  }

}


